import { StyleSheet, Platform } from 'react-native';

import { Colors } from '../Themes';

export default StyleSheet.create({
  badgeStyle: {
    borderRadius: 20.8,
    paddingHorizontal: 12,
    paddingBottom: 3,
    paddingTop: Platform.OS === 'ios' ? 5 : 3,
  },
  positiveBadgeStyle: theme => ({
    backgroundColor: theme.colors.badge.positive,
  }),
  neutralBadgeStyle: theme => ({
    backgroundColor: theme.colors.badge.neutral,
  }),
  criticalBadgeStyle: theme => ({
    backgroundColor: theme.colors.badge.critical,
  }),
  processingBadgeStyle: theme => ({
    backgroundColor: theme.colors.badge.processing,
  }),
  badgeTextStyle: {
    color: Colors.white,
    fontSize: 14.6,
    marginBottom: 1,
  },
});
